<template>
  <div class="opea-items">
    <div id="canvas" class="like" :class="device == 'wap' ? 'wap' : ''"></div>
    <span
      class="icon icontemp collect"
      :class="device == 'wap' ? 'wap' : ''"
      @click="like()"
    ></span>
    <span
      class="opea-text"
      :class="device == 'wap' ? 'wap' : ''"
      v-show="!isHideLikeNum"
      >{{
        likeNum >= 10000 ? formatDecimal(likeNum / 10000, 1) + "W" : likeNum
      }}</span
    >
    <!--<span class="opea-text" :class="device == 'wap'?'wap':''" v-show="!isHideLikeNum">{{likeNum>=10000?parseFloat((likeNum/10000).toFixed(1))+'W':likeNum}}</span>-->
  </div>
</template>

<script>
import BubbleHearts from "../../common/bubble-hearts";
import { $subscriber } from "fire-wind-water";
import ws from "../../services/webinar";
import { socketModule } from "../../common/socket";
import $ from "jquery";
export default {
  name: "File",
  props: {
    device: String
  },
  data() {
    return {
      assets: [
        require("../../assets/images/heart.png"),
        require("../../assets/images/heart.png"),
        require("../../assets/images/heart.png"),
        require("../../assets/images/heart.png")
      ],
      cavans: null,
      images: [],
      random: {},
      webinarInfo: {},
      userInfo: {},
      timer: null,
      onLikeRandom: new Date().getTime(),
      isHideLikeNum: false,
      likeNum: 0
    };
  },
  methods: {
    like() {
      let self = this;
      let image =
        self.images[self.random.uniformDiscrete(0, self.images.length - 1)];
      self.stage.bubble(image, 1);
      if (self.timer) {
        clearTimeout(self.timer);
      }
      self.timer = setTimeout(() => {
        socketModule.emit("onLike", {
          userId: self.userInfo.id,
          webinarId: self.webinarInfo.webinarId,
          random: self.onLikeRandom
        });
      }, 200);
    },
    likeInit(isInit) {
      let self = this;
      //      var assets = [
      //        require('../../assets/images/heart.png'),
      //        require('../../assets/images/heart.png'),
      //        require('../../assets/images/heart.png'),
      //      ];
      self.assets.forEach(function(src, index) {
        self.assets[index] = new Promise(function(resolve) {
          var img = new Image();
          img.onload = resolve.bind(null, img);
          img.src = src;
          img.height = img.width = self.device == "wap" ? 55 : 80;
          //            img.height = 32;
          img.style.opacity = 0.3;
        });
      });
      Promise.all(self.assets)
        .then(function(images) {
          self.images = images;
          self.random = {
            uniform: function(min, max) {
              return min + (max - min) * Math.random();
            },
            uniformDiscrete: function(i, j) {
              return i + Math.floor((j - i + 1) * self.random.uniform(0, 1));
            }
          };
          if (isInit) {
            self.stage = new BubbleHearts();
            self.canvas = self.stage.canvas;
            document.getElementById("canvas").appendChild(self.canvas);

            self.canvas.width = $("#canvas").width() * 2;
            self.canvas.height = $("#canvas").height() * 2;
          }
          //          setInterval(function () {
          //            self.stage.bubble(images[self.random.uniformDiscrete(0, images.length - 1)],0.3);
          //          }, 700);

          // Bubble animation as custom
          //        self.canvas.addEventListener('click', function () {
          //          let image = images[random.uniformDiscrete(0, images.length - 1)];
          //          stage.bubble(image);
          //        }, false);
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    formatDecimal(num, decimal) {
      num = num.toString();
      let index = num.indexOf(".");
      if (index !== -1) {
        num = num.substring(0, decimal + index + 1);
      } else {
        num = num.substring(0);
      }
      return parseFloat(parseFloat(num).toFixed(decimal));
    },
    initLikeConfig(info, isInit) {
      let self = this;
      if (info.config.iconState == 1) {
        let assets = JSON.parse(info.config.iconUrl);

        self.assets = [];
        for (let i of assets) {
          if (i) {
            self.assets.push(i);
          }
        }
        if (self.assets.length == 0) {
          self.assets = [require("../../assets/images/heart.png")];
        }
      } else {
        self.assets = [require("../../assets/images/heart.png")];
      }
      self.isHideLikeNum = info.config.hide == 1;
      self.likeNum = info.num || 0;
      self.likeInit(isInit);
    }
  },
  created() {
    let self = this;
    $subscriber.on("onLike", data => {
      self.likeNum = data.num || 0;
      if (self.onLikeRandom != data.random) {
        self.stage.bubble(
          self.images[self.random.uniformDiscrete(0, self.images.length - 1)],
          1
        );
      }
    });
    $subscriber.subscribe("userInfo", data => {
      this.userInfo = data;
    });
    $subscriber.subscribe("webinarInfo", data => {
      self.webinarInfo = data;
      ws.getLikeConfig(data).then(info => {
        self.initLikeConfig(info.content, true);
      });
    });
    $subscriber.subscribe("onLikeConfig", data => {
      self.initLikeConfig(data, false);
    });
  },
  mounted() {}
};
</script>

<style scoped></style>
